import { PropsWithChildren, isValidElement } from 'react';
import { Card } from '../../components/card/card';
import { Typography } from '../../components/typography/typography';
import classNames from 'classnames';
import Icon from '../../components/icons/icon';
import { Button } from '../../components/form/button';

export const CheckoutStep = ({
  title,
  step,
  isCompleted = false,
  isEditDisabled = false,
  hideEdit = false,
  children,
  contentPadding = 'py-4 px-3',
  onEdit,
}: PropsWithChildren<{
  title: string;
  step: number;
  isCompleted?: boolean;
  contentPadding?: string;
  isEditDisabled?: boolean;
  hideEdit?: boolean;
  onEdit?: () => void;
}>) => {
  const hasChildren = children !== undefined && isValidElement(children);

  return (
    <Card className="rounded-lg shadow-sm px-0">
      <div className="flex flex-col">
        <div
          className={classNames({
            'border-b border-x-0 border-t-0 border-solid border-grey-200': hasChildren,
          })}
        >
          <div className="flex justify-between py-4 px-3">
            <div className="flex gap-2 items-center">
              <div
                className="relative overflow-hidden w-6 h-6 rounded-full
          border-2 border-solid border-primary-500"
              >
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                  {isCompleted ? (
                    <div className="flex items-center">
                      <Icon
                        icon="Check"
                        stroke="var(--primary-color-500)"
                        size="small"
                        strokeWidth={6}
                        data-cy="icon-check"
                      />
                    </div>
                  ) : (
                    <span className="font-semibold text-quipli-black-800">{step}</span>
                  )}
                </div>
              </div>

              <Typography type="text-md">{title}</Typography>
            </div>

            {isCompleted && !hideEdit && (
              <Button data-cy="edit-button" className="icon-button !p-0" onClick={() => !isEditDisabled && onEdit?.()}>
                <Icon icon="Edit" stroke="var(--grey-400)" data-cy="icon-edit" />
              </Button>
            )}
          </div>
        </div>

        {hasChildren && <div className={classNames(contentPadding)}>{children}</div>}
      </div>
    </Card>
  );
};
